import React from 'react'
import Header from '../common/header/Header'
import TotalCount from './total-count'
import AllowedAccess from '../../guards/AllowedAccess'
import Permission from '../../guards/PermissionList';
import { COMPONENTTYPE } from '../common/constant/componentType'

const Dashboard = () => {
    return (
        <div>
            <Header headertitle="Dashboard" />
            <AllowedAccess
                type={COMPONENTTYPE.ELEMENT}
                permissions={[Permission.dashboard.dashboard_view]}
                isAuthMsg={true}
            >
                <TotalCount />
            </AllowedAccess>
        </div>
    )
}

export default Dashboard;
